import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import moment from "jalali-moment";
import { Link } from "react-router-dom";

import Layout from "../../../component/Layout/Layout";
import Card from "../../../component/Layout/theme/card";
import LogOut from "../../../component/dashboard/user/logout/logout";
import PageChange from "../../../component/pageChange";
import { Tabs, Tab } from "../../../component/tabs/index";
import toast from "react-hot-toast";


function IndexPage() {
    var { t } = useTranslation()
    const { login, token } = useSelector((item) => item.user)
    const [isDataLoad, setIsDataLoad] = useState(false);
    const [billingData, setBillingData] = useState([])


    useEffect(() => {
        document.title = "پلن های مالی"
        if (!login) {
            window.location.href = '/auth'
        } else {
            getPaymentMethodData()
        }
    }, [])

    async function getPaymentMethodData() {
        // توکن ب سرور داده شده و اطلاعات کاربر دریافت
        await fetch(`${process.env.REACT_APP_SERVER}/api/billing/`, {
            method: "GET",
            headers: {
                Authorization: "ArNew " + token,
            },
        }).then((res) => {
            res
                .json()
                .then((result) => {
                    if (!result.data) {
                        LogOut();
                        toast.error("شما دسترسی ندارید");
                        window.location.href = '/login';
                    }
                    if (result.status === "success") {
                        setIsDataLoad(true)
                        setBillingData(result.data)
                    } else {
                        toast.error(result.msg);
                        LogOut();
                        window.location.href = '/login';
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        });
    }



    const getPricePay = (data) => {
        if (data.plan.currency === "FREE") {
            return "رایگان"
        } else {
            if (data.payment != null) {
                return data.payment.amount.toLocaleString('en-US')
            } else {
                return data.plan.price.toLocaleString('en-US')
            }
        }
    }

    const getPeriodPay = (period) => {
        switch (period) {
            case "UNLIMITED":
                return "نامحدود"
            case "MONTHLY":
                return "ماهانه"
            case "YEARLY":
                return "سالانه"
            default:
                return "نامشخص"
        }
    }


    const getHistoryPlans = (type, data) => {

        var items = []
        switch (type) {
            case "NOTACTIVE":
                items = data.notActive
                break;
            case "WAITLIST":
                items = data.waitList
                break;
            case "FAILD":
                items = data.faild
                break;
            default:
                items = []
                break;
        }
        return (
            items.length != 0 ?
                items.map((item, index) => {
                    return (
                        <div key={`${type}(${index})`} className="p-8 mb-24 bg-[#f2f4f6] rounded-lg border border-[#e6e8ea]">
                            <div className="grid grid-cols-2 xl:grid-cols-7 lg:grid-cols-3 gap-3">
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">اکانت</span>
                                    <h3 className="font-extrabold text-xl text-start text-black py-5">{item.plan.name}</h3>
                                </div>
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">وضعیت پرداخت</span>
                                    <h3 className="font-extrabold text-xl text-start text-black py-5">{item.plan.currency == "FREE" ? "هدیه" : item.status_payment ? "پرداخت شده" : "پرداخت ناموفق"}</h3>
                                </div>
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">مبلغ پرداخت</span>
                                    <h3 className="font-extrabold text-xl text-start text-black py-5">{getPricePay(item)}</h3>
                                </div>
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">تاریخ ایجاد</span>

                                    <h3 className="font-extrabold text-xl text-start text-black py-5">{moment(new Date(parseInt(item.create_in))).format(
                                        "jYYYY/jMM/jDD"
                                    )}</h3>
                                </div>
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">تاریخ پایان</span>
                                    <h3 className="font-extrabold text-xl text-start text-black py-5">{item.plan.currency == "FREE" ? "نامحدود" : moment(new Date(parseInt(item.expire_in))).format(
                                        "jYYYY/jMM/jDD"
                                    )}</h3>
                                </div>
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">دوره</span>
                                    <h3 className="font-extrabold text-xl text-start text-black py-5">{getPeriodPay(item.plan.period)}</h3>
                                </div>
                                <div className="flex justify-center m-auto">
                                    <Link to={`/billing/payment/${item._id}`}>
                                        <button className="w-full font-medium text-lg text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg px-5 py-2.5 text-center">دانلود فاکتور</button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    )
                })
                :
                (
                    <div className="grid place-items-center mb-5">
                        <img className="free-image w-[150px] h-[150px]" src={process.env.REACT_APP_ADDRESS + "/panel/no-content-bill.png"} />
                        <span className="font-normal text-lg text-gray-400 mt-5">
                            اشتراکی موجود نیست
                        </span>
                    </div>

                )
        )
    }


    return (
        <>
            <Layout />
            <Card>
                {isDataLoad ? (

                    <div className="p-5 mb-24 bg-white rounded-lg shadow-md">
                        <h1 className="font-extrabold text-2xl text-start text-black mt-5">صورت‌حساب «فضای کاری من»</h1>
                        <h4 className="font-normal text-lg text-start text-gray-500 mt-2">طرح خود را تغییر دهید، اطلاعات صورتحساب خود را به روز کنید و فاکتورهای خود را دانلود کنید</h4>
                        <h1 className="font-extrabold text-xl text-start text-black my-8 mx-5">اشتراک فعال</h1>
                        {
                            billingData.active != null ?
                                (
                                    <div className="p-8 mb-24 bg-[#f2f4f6] rounded-lg border border-[#e6e8ea]">
                                        <div className="grid grid-cols-2 xl:grid-cols-7 lg:grid-cols-3 gap-3">
                                            <div className="">
                                                <span className="font-bold text-start text-gray-400">اکانت فعلی</span>
                                                <h3 className="font-extrabold text-xl text-start text-black py-5">{billingData.active.plan.name}</h3>
                                            </div>
                                            <div className="">
                                                <span className="font-bold text-start text-gray-400">تعداد واقعیت افزوده</span>
                                                <h3 className="font-extrabold text-xl text-start text-black py-5">{billingData.active.plan.count == 0 ? "نامحدود" : billingData.active.plan.count}</h3>
                                            </div>
                                            <div className="">
                                                <span className="font-bold text-start text-gray-400">محدودیت بازدید</span>
                                                <h3 className="font-extrabold text-xl text-start text-black py-5">{billingData.active.plan.view_limited == 0 ? "نامحدود" : billingData.active.plan.view_limited}</h3>
                                            </div>
                                            <div className="">
                                                <span className="font-bold text-start text-gray-400">قیمت</span>
                                                <h3 className="font-extrabold text-xl text-start text-black py-5">{getPricePay(billingData.active)}</h3>
                                            </div>
                                            <div className="">
                                                <span className="font-bold text-start text-gray-400">دوره</span>
                                                <h3 className="font-extrabold text-xl text-start text-black py-5">{getPeriodPay(billingData.active.plan.period)}</h3>
                                            </div>
                                            <div className="">
                                                <span className="font-bold text-start text-gray-400">اتمام دوره</span>
                                                <h3 className="font-extrabold text-xl text-start text-black py-5">{billingData.active.expire_in == billingData.active.create_in ? "نامحدود" : moment(new Date(parseInt(billingData.active.expire_in))).format(
                                                    "jYYYY/jMM/jDD"
                                                )}</h3>
                                            </div>
                                            <div className="flex w-full justify-start m-auto">
                                                <Link to="/billing/plan">
                                                    <button className=" font-medium text-sm text-white  bg-red-600 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-blue-300  rounded-lg   sm:w-auto px-5 py-2.5 text-center">ارتقای پنل</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                )
                                :
                                (
                                    <div className="grid place-items-center ">
                                        <img className="free-image w-[150px] h-[150px]" src={process.env.REACT_APP_ADDRESS + "/panel/no-content-bill.png"} />
                                        <span className="font-normal text-lg text-gray-400 mt-5">
                                            اشتراکی فعالی موجود نیست
                                        </span>
                                        <div className="mt-2">
                                            <Link to="/billing/plan">
                                                <button className=" font-medium text-sm text-white  bg-red-600 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-blue-300  rounded-lg   sm:w-auto px-5 py-2.5 text-center">ارتقای پنل</button>
                                            </Link>
                                        </div>
                                    </div>

                                )
                        }


                        <h1 className="font-extrabold text-xl text-start text-black my-8 mx-5">تاریخچه اشتراک ها</h1>

                        <Tabs>
                            <Tab key={"WAITLIST"} component={getHistoryPlans("WAITLIST", billingData)} active>غیرفعال</Tab>
                            <Tab key={"NOTACTIVE"} component={getHistoryPlans("NOTACTIVE", billingData)} >اتمام دوره</Tab>
                            <Tab key={"FAILD"} component={getHistoryPlans("FAILD", billingData)}>ناموفق</Tab>
                        </Tabs>

                    </div>
                ) : (
                    <PageChange />
                )}

            </Card>
        </>
    )
}

export default IndexPage